import { render, staticRenderFns } from "./modalCompartilhar.vue?vue&type=template&id=399eaa3e&"
import script from "./modalCompartilhar.vue?vue&type=script&lang=js&"
export * from "./modalCompartilhar.vue?vue&type=script&lang=js&"
import style0 from "./modalCompartilhar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports